import { lazy } from 'react';

const KnowledgeBase = lazy(() => import('./KnowledgeBase'));

export default KnowledgeBase;
